import axios from 'axios'
import {Currency} from '../models/currency'

const API_URL = process.env.REACT_APP_API_URL

export const getCurrencies = async (page: number = 0, pageSize: number = 10) => {
  try {
    const response = await axios.get(`${API_URL}/currencies`, {
      params: {
        page,
        pageSize,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCurrency = async (id: string) => {
  try {
    const response = await axios.get(`${API_URL}/currencies/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const createCurrency = async (currency: Currency) => {
  try {
    const response = await axios.post(`${API_URL}/currencies`, currency)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCurrency = async (id: string, currency: Currency) => {
  try {
    const response = await axios.patch(`${API_URL}/currencies/${id}`, currency)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteCurrency = async (id: string) => {
  try {
    const response = await axios.delete(`${API_URL}/currencies/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
} 